import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  MuiThemeProvider,
  createMuiTheme,
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { deleteForm, getFormById, postForm, updateForm } from '../../../../api/form'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'

const theme = createMuiTheme({
  palette: { secondary: { main: '#F64E60' } },
})

function getEmpty() {
  return {
    title: '',
    googleFormsUrl: '',
    active: true,
    order: 0,
  }
}

export default function EditFormPage() {
  const [form, setForm] = useState(getEmpty())
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const formId = useParams().id
  const history = useHistory()
  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (!formId) {
      disableLoadingData()
      return
    }
    getFormById(formId)
      .then((res) => {
        if (res.status === 200) {
          setForm(res.data)
          disableLoadingData()
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudo cargar el formulario.' })
        history.push('/forms')
      })
  }, [formId, disableLoadingData, history])

  function save() {
    if (!form.title || !form.googleFormsUrl) {
      alertError({ error: null, customMessage: 'Título y URL de Google Forms son obligatorios.' })
      return
    }
    const payload = {
      title: form.title,
      googleFormsUrl: form.googleFormsUrl,
      active: form.active !== false,
      order: Number(form.order) || 0,
    }
    const req = formId ? updateForm(formId, payload) : postForm(payload)
    req
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          alertSuccess({ title: 'Guardado', customMessage: 'Formulario guardado.' })
          history.push('/forms')
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudo guardar.' })
      })
  }

  if (isLoadingData) return <ContentSkeleton />

  return (
    <>
      <Card>
        <CardHeader title={formId ? 'Editar formulario' : 'Nuevo formulario'} />
        <CardBody>
          <TextField
            label="Título"
            value={form.title || ''}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            margin="normal"
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            label="Enlace Google Forms"
            value={form.googleFormsUrl || ''}
            onChange={(e) => setForm({ ...form, googleFormsUrl: e.target.value })}
            margin="normal"
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            label="Orden"
            type="number"
            value={form.order ?? 0}
            onChange={(e) => setForm({ ...form, order: e.target.value })}
            margin="normal"
            variant="outlined"
          />
          <br />
          <FormControlLabel
            control={
              <Checkbox
                checked={form.active !== false}
                onChange={() => setForm({ ...form, active: !(form.active !== false) })}
              />
            }
            label="Activo"
          />
        </CardBody>
      </Card>
      <Button onClick={() => history.push('/forms')} variant="outlined" style={{ marginRight: 20 }}>
        Volver
      </Button>
      <Button onClick={save} variant="outlined" color="primary" style={{ marginRight: 20 }}>
        Guardar
      </Button>
      {formId && (
        <>
          <MuiThemeProvider theme={theme}>
            <Button onClick={() => setOpenConfirmDialog(true)} variant="outlined" color="secondary">
              Eliminar
            </Button>
          </MuiThemeProvider>
          <ConfirmDialog
            title="¿Eliminar este formulario?"
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteForm(formId)
                .then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    alertSuccess({ title: 'Eliminado', customMessage: 'Formulario eliminado.' })
                    history.push('/forms')
                  }
                })
                .catch((error) => {
                  alertError({ error, customMessage: 'No se pudo eliminar.' })
                })
            }}
          />
        </>
      )}
    </>
  )
}
